'use strict';

angular.module('servicesController', [])

.controller('ServicesController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window','BuyerService', 'CommonService',
    function (appInfo, $scope, $rootScope, $log, $location, $window, BuyerService, CommonService) {    
    
    var currentUser = $rootScope.currentUser;
    $scope.page = 'services';
    $scope.services = [];
    var init = function() {
        loadServices();
    }

    var loadServices = function() {
        $rootScope.loading = true;   
        BuyerService.getServices()
        .then(function(data){
            $scope.services = data;
            $rootScope.loading = false;   
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){
            $rootScope.loading = false;    
        });
    }

    init();

}]);